'use strict';

import * as Onyx from '../../lib/onyx.min.js';

import {default as Background} from '../../entities/background';
import {default as Player} from '../../entities/player';

import {default as FrameBufferTexture2DCaustic} from '../../shaders/caustic';
import {default as FrameBufferTexture2DGodRays} from '../../shaders/godrays';

// @route('title') //<-- Is this possible?
export default class SceneTitle extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/title/index.html',
            // sceneURL: 'title.oxsc',
            clock: new Onyx.Clock()
        });
    }

    onload(){
        super.onload();

        // Hide Build Date Warning
        document.getElementById('build-date-warning').style.display = 'none';

		document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.first_name}", centralStation.player.first_name);
		document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.last_name}", centralStation.player.last_name);
        
        this.camera = new Onyx.Camera({followType: "EaseOut", stiffness: 0.2});
        this.add(this.camera);
        this.camera.limit.minimum.x = 0;
        this.camera.limit.minimum.y = 0;
        this.camera.limit.maximum.y = 475;
        this.viewports[0].bindToCamera(this.camera);

        let precision = this.viewports[0].webgl.getShaderPrecisionFormat(this.viewports[0].webgl.FRAGMENT_SHADER, this.viewports[0].webgl.HIGH_FLOAT);
        if(precision.rangeMax < 15){
            this.caustic = new Onyx.Texture("res/textures/caustics-fallback.png", {flipY: true, wrap: {s: "REPEAT", t: "REPEAT"}});
            this.caustic.load();
            this.caustic.img.width = 256;
            this.caustic.scale = 8;
            this.godrays = new Onyx.Texture("res/textures/rays-fallback.png", {flipY: true, wrap: {s: "REPEAT", t: "REPEAT"}});
            this.godrays.load();
            this.godrays.img.width = 128;
            this.godrays.scale = 1;
        }else{
            this.caustic = new FrameBufferTexture2DCaustic();
            this.viewports[0].addFrameBufferTexture(this.caustic);
            this.godrays = new FrameBufferTexture2DGodRays();
            this.viewports[0].addFrameBufferTexture(this.godrays);
        }

        let newEntity = new Background([1200, 0, -1500], 1, 0, {
            godrays: this.godrays,
            caustic: this.caustic,
            columnCount: 5,
            rowCount: 30
        });
        this.add(newEntity);

        this.player = new Player([150, 150, 0], 1, 0, {
            godrays: this.godrays,
            caustic: this.caustic,
            translateX: 0,
            rotateY: 0
        });
        this.player.transform.rotateToY(Math.PI / 2);
        this.add(this.player);
        this.camera.follow(this.player, [0, 30, 200]);
        
        this.ambientLightColor.set(0.5, 0.5, 0.5);
        this.directionalLightVector.set([-0.25, 0.8, 0.75]);
        this.fogColor.set(64 / 255, 130 / 255, 131 / 255);
        this.fogDensity = 1.25;

        this.setTimeout(() => {
            this.play();
        }, 20000);

        // Rotate camera on device rotation
        if ( window.DeviceMotionEvent ) { 
            window.ondeviceorientation = (event) => {
                let alpha = event.alpha / 180*Math.PI;
                let beta = event.beta / 180*Math.PI;
                let gamma = event.gamma / 180*Math.PI;
                let scale = 0.3;

                // Prevent camera from flipping
                if(beta < -2 || beta > 2) return;
                
                this.camera.transform.rotateToXYZ(0, beta * scale);
            }  
        }
    }

    onunload(){
        super.onunload();

        // game.music['music'].stop();

        this.entities = [];
        delete this.player;
    }

    @Onyx.handles('click') //, {elementId: 'start'}
    play(){ 
        game.showLoadingMask();

        this.setTimeout(() => {
            this.clock.stop();

            // window.setTimeout(function(){ // Give the browser a second to breathe and cleanup and garbage
                router.navigate("game"); 
            // }, 1000);
        }, 1000);
        
        // game.sfx["sndButtonPress"].play();
    }

    update(...args){
        super.update(...args);

        if(this.player) this.player.transform.z--;
    }
}